export default {
    "ru": {
        title: "Размер гексагона",
        loading: "Загрузка…",
        default: "по умолчанию",
        available: "доступно",
        errors: {
            loadFailed: "Не удалось загрузить размеры гексагонов",
            emptySizes: "Нет доступных размеров"
        },
        tooltip: {
            default: "Используется стандартный размер",
            disabled: "Только один доступный размер",
            select: "Выберите размер гексагона"
        }
    },
    "en": {
        title: "Hexagon Size",
        loading: "Loading…",
        default: "default",
        available: "available",
        errors: {
            loadFailed: "Failed to load hexagon sizes",
            emptySizes: "No sizes available"
        },
        tooltip: {
            default: "Using default size",
            disabled: "Only one size available",
            select: "Select hexagon size"
        }
    }
};